export default "__VITE_ASSET__DLHbS9li__"